import { LoginResponseInfoMapper } from "@/data/mapper/login-response-info-mapper";
import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { LoginSource } from "@/data/source/login-source";
import { LoginResponseInfoEntity } from "@/domain/entity/login-response-info-entity";
import { LoginRepository } from "@/domain/repository/login-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LoginRepositoryImpl implements LoginRepository {
  constructor(private readonly loginSource: LoginSource) {}

  async login(
    payload: LoginRequestPayload,
  ): Promise<SATResult<LoginResponseInfoEntity, SATError>> {
    const result = await this.loginSource.login(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      LoginResponseInfoMapper.toEntity,
      "LoginRepositoryImpl::login",
    );
  }

  async logout(): Promise<SATResult<void, SATError>> {
    const result = await this.loginSource.logout();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
